// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.noti_questions[data-v-3d96a50a] {\n  font-size: 18px;\n  font-weight: bolder;\n}\n.multiline-editor[data-v-3d96a50a] {\n    white-space: pre !important;\n}\n", ""]);
// Exports
module.exports = exports;
